// extracted by mini-css-extract-plugin
export default {"LobbyList":"LobbyList_LobbyList__vxp9J","LobbyItem":"LobbyList_LobbyItem__GG+Z2"};